/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from './subheader.component.scss.ngstyle';
import * as import1 from '@angular/core';
import * as import2 from '../../../../../app/shared/decorator/subheader/subheader.component';
const styles_SubHeaderComponent:any[] = [import0.styles];
export const RenderType_SubHeaderComponent:import1.RendererType2 = import1.ɵcrt({
  encapsulation: 2,
  styles: styles_SubHeaderComponent,
  data: {}
}
);
export function View_SubHeaderComponent_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),14,'div',[[
        'id',
        'category-header'
      ]
      ],[[
        8,
        'className',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n  '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),11,'div',[[
        'class',
        'row no-gutters'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'col'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'col-10'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n      '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'category-title'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵted((null as any),['\n    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'col'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵted((null as any),['\n'])),
    (l()(),import1.ɵted((null as any),['\n']))
  ]
  ,(null as any),(ck,v) => {
    var co:import2.SubHeaderComponent = v.component;
    const currVal_0:any = ('container-fluid header ' + co.class);
    ck(v,0,0,currVal_0);
    const currVal_1:any = co.title;
    ck(v,9,0,currVal_1);
  });
}
function View_SubHeaderComponent_Host_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'subheader',([] as any[]),(null as any),(null as any),(null as any),View_SubHeaderComponent_0,RenderType_SubHeaderComponent)),
    import1.ɵdid(49152,(null as any),0,import2.SubHeaderComponent,([] as any[]),(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const SubHeaderComponentNgFactory:import1.ComponentFactory<import2.SubHeaderComponent> = import1.ɵccf('subheader',import2.SubHeaderComponent,View_SubHeaderComponent_Host_0,{
  title: 'title',
  class: 'class'
}
,{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci9idWlsZC9ob3dtdWNoL3NyYy9hcHAvc2hhcmVkL2RlY29yYXRvci9zdWJoZWFkZXIvc3ViaGVhZGVyLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy92YXIvYnVpbGQvaG93bXVjaC9zcmMvYXBwL3NoYXJlZC9kZWNvcmF0b3Ivc3ViaGVhZGVyL3N1YmhlYWRlci5jb21wb25lbnQudHMiLCJuZzovLy92YXIvYnVpbGQvaG93bXVjaC9zcmMvYXBwL3NoYXJlZC9kZWNvcmF0b3Ivc3ViaGVhZGVyL3N1YmhlYWRlci5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3Zhci9idWlsZC9ob3dtdWNoL3NyYy9hcHAvc2hhcmVkL2RlY29yYXRvci9zdWJoZWFkZXIvc3ViaGVhZGVyLmNvbXBvbmVudC50cy5TdWJIZWFkZXJDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8ZGl2IGlkPVwiY2F0ZWdvcnktaGVhZGVyXCIgW2NsYXNzXT1cIidjb250YWluZXItZmx1aWQgaGVhZGVyICcgKyBjbGFzcyBcIiA+XG4gIDxkaXYgY2xhc3M9XCJyb3cgbm8tZ3V0dGVyc1wiPlxuICAgIDxkaXYgY2xhc3M9XCJjb2xcIj48L2Rpdj5cbiAgICA8ZGl2IGNsYXNzPVwiY29sLTEwXCI+XG4gICAgICA8ZGl2IGNsYXNzPVwiY2F0ZWdvcnktdGl0bGVcIj57e3RpdGxlfX08L2Rpdj5cbiAgICA8L2Rpdj5cbiAgICA8ZGl2IGNsYXNzPVwiY29sXCI+PC9kaXY+XG4gIDwvZGl2PlxuPC9kaXY+XG4iLCI8c3ViaGVhZGVyPjwvc3ViaGVhZGVyPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O01DQUE7UUFBQTtRQUFBO01BQUE7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBd0U7TUFDdEU7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUE0QjtNQUMxQjtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQXVCO01BQ3ZCO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBb0I7TUFDbEI7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUE0QjtNQUFBO01BQUE7SUFBQTtJQUFBO0lBQWU7SUFDdkM7TUFDTjtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQXVCO0lBQ25CO0lBQ0Y7Ozs7SUFSb0I7SUFBMUIsU0FBMEIsU0FBMUI7SUFJa0M7SUFBQTs7Ozs7SUNKbEM7Z0JBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// ./src/ngfactory/app/shared/decorator/subheader/subheader.component.ngfactory.ts